import {PlanCode} from 'ApplicationEntry/models/PlanCode';
import * as PI from 'ApplicationEntry/models/PlanCode';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum PlanCodeActionType {
  EDIT_PLAN_CODE = 'planCodes/EDIT_PLAN_CODE',
  CHANGE_UNITS = 'planCodes/CHANGE_UNITS',
}

export const isPlanCodeAction = (action: any): action is PlanCodesAction =>
  action.type in reverseEnum(PlanCodeActionType);

export const editPlanCode = (
  phase: string,
  planCode: string,
  units: number,
  description: string,
  onTheJobRiderBenefit: number
) => createAction(PlanCodeActionType.EDIT_PLAN_CODE, {phase, planCode, units, description, onTheJobRiderBenefit});
export const changeUnits = (units: number) => createAction(PlanCodeActionType.CHANGE_UNITS, {units});

export type PlanCodesAction = ReturnType<typeof editPlanCode> | ReturnType<typeof changeUnits>;

type PlanCodeState = PlanCode;

export default (state: PlanCodeState, action: PlanCodesAction) => {
  switch (action.type) {
    case PlanCodeActionType.EDIT_PLAN_CODE:
      return PI.updateItem(
        action.payload.phase,
        action.payload.planCode,
        action.payload.description,
        action.payload.units,
        action.payload.onTheJobRiderBenefit
      )(state);
    case PlanCodeActionType.CHANGE_UNITS:
      return PI.changeUnits(action.payload.units)(state);
    default:
      return state;
  }
};
